import styled from "@emotion/styled/macro";
import { SvgIcon, SvgNames } from "@sunrun/experience-ui-components";

type NavigateBackHeaderProps = {
  title: string;
  onBack: () => void;
};

const NavigateBackHeader = ({ title, onBack }: NavigateBackHeaderProps) => {
  return (
    <HeaderContainer>
      <BackButton onClick={onBack} data-testid="navigate-back-btn">
        <SvgIcon
          name={SvgNames.ChevronLeft}
          width="24"
          height="24"
          color="#333"
        />
      </BackButton>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  height: 58px;
  padding: 24px 24px 12px 16px;
  background-color: transparent;
  z-index: 98;
  position: sticky;
`;

const BackButton = styled.button`
  background: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  &:hover {
    background-color: #e8e8e8;
  }
`;

export { NavigateBackHeader };
